module.exports = __webpack_public_path__ + "img/ic_property_terraced.a7eb0bb8.svg";